import { useParams } from "react-router-dom";
// import data
import contentData from "../../../data/content/about/AIPlatformContent.json";
import { DataKeys, DataStructure } from "../../../types";
// import components
import { NavTree, ExploreOtherServices } from "../../navigation/NavLinkPages";
import { TechBanner } from "./About";
import NoContent from "../../content/NoContent";
// import function
import { DisplayInfo2Cols } from "../../../functions/DisplayInfoFunctions";
// import context
import { useLang } from "../../Context";

const typedContent : DataStructure = contentData;
const imagePath = "image/about/aiPlatforms/";


export default function AboutTechSubpages() {
    const { lang } = useLang();
    const { aboutTech } = useParams();

    const data = aboutTech
        ? (typedContent[aboutTech] as DataStructure | undefined)
        : undefined;
    const contentData = data?.["content"] as DataStructure | undefined;
    const exploreData = data?.["explore"] as DataKeys | undefined;

    if (!data) {
        return <NoContent />;
    }

    return (
        <>
            <TechBanner title={data["title"][lang]} subtitle={data["subtitle"][lang]} />
            <NavTree />
            {contentData && (
                <DisplayInfo2Cols
                    contentData={contentData}
                    imagePath={imagePath}
                    title={data["header"][lang]}
                />
            )}
            {exploreData && (
                <ExploreOtherServices
                    titleKey={exploreData["title"]}
                    servicesList={exploreData["list"]}
                />
            )}
        </>
    );
}
